<template>
  <section class="positioner">
    <attempts-table
      v-if="attemptsTableState.visible"
      class="attempts-table"
      :attempts="attemptsTableState.attempts"
      :player-info="attemptsTableState.playerInfo"
      :position="attemptsTableState.position"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { attemptsTableState } from '@/stores'
import { AttemptsTable } from '@powerplay/core-minigames-ui-ssm'

export default defineComponent({
  name: 'AttemptsTableComponent',
  components: {
    AttemptsTable
  },
  data() {

    return {
      attemptsTableState: attemptsTableState()
    }

  },
})

</script>

<style lang='less' scoped>
.positioner {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .attempts-table {
    width: 1250px;
    position: absolute;
    transform-origin: 50% 100%;
    bottom: 7%;
  }

}
</style>
